import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getCourseDescr, getCoursesDescr } from 'utils';

function HistoryDetails({
  historyRequirements,
  historySubsections,
  historyDeleted,
  historyCourseListRequirements,
  subsectionName,
  handleClose,
}) {
  const actionLabelMap = {
    'REQUIREMENT-MODIFY': 'Edited list item',
    'REQUIREMENT-DELETE': 'Deleted list item',
    'REQUIREMENT-ADDED': 'Added list item',
  };
  console.log('historyDeleted: ', historyDeleted);
  const courseLists = useSelector((state) => state.checksheet.courseLists);
  const reverseData = [
    ...(historyRequirements || []),
    ...(historySubsections || []),
  ].reverse();

  function compareObjects(obj1String, obj2String) {
    const obj1 = obj1String ? JSON.parse(obj1String) : {};
    const obj2 = obj2String ? JSON.parse(obj2String) : {};
    const differences = [];

    if (obj2.requirementId) {
      const courses1 = obj1.courses || [];
      const courses2 = obj2.courses || [];

      let coursesDescr1 = '';
      let coursesDescr2 = '';

      for (let i = 0; i < Math.max(courses1.length, courses2.length); i++) {
        const course1 = courses1[i];
        const course2 = courses2[i];
        if (course1 !== undefined) {
          coursesDescr1 += getCourseDescr(course1, courseLists);
        }
        coursesDescr2 += getCourseDescr(course2, courseLists);
      }
      if (coursesDescr1 !== coursesDescr2) {
        differences.push({
          key: coursesDescr1 === '' ? 'new' : 'description',
          obj1: coursesDescr1,
          obj2: coursesDescr2,
        });
      }

      ['hours', 'grade', 'notes'].forEach((key) => {
        if (obj1[key] !== obj2[key] && coursesDescr1 !== '') {
          differences.push({
            key,
            obj1: obj1[key],
            obj2: obj2[key],
          });
        }
      });
    } else if (obj2.subsectionId) {
      const subsectionName1 = obj1.subsectionName || '';
      const subsectionName2 = obj2.subsectionName || '';

      if (subsectionName1 !== subsectionName2) {
        differences.push({
          key: subsectionName1 === '' ? 'new' : 'description',
          obj1: subsectionName1,
          obj2: subsectionName2,
        });
      }
    }

    return differences;
  }

  const hasDeleted = historyDeleted?.length > 0;
  useEffect(() => {
    document.querySelectorAll('[data-connector]').forEach((el) => {
      const connector = el.getAttribute('data-connector');
      if (connector) {
        el.classList.add(connector); // Dynamically use the connector as className
      }
    });
  }, []);

  return (
    <div
      style={{
        width:
          historyCourseListRequirements?.length > 0
            ? '1000px'
            : hasDeleted
              ? '800px'
              : '400px',
      }}
    >
      {/* Close Button */}
      <button
        className="border border-gray-3 rounded-circle lh-1"
        style={{ padding: '7px 10px', float: 'right' }}
        onClick={handleClose}
        aria-label="Close"
      >
        <FontAwesomeIcon
          icon={faXmark}
          width="10px"
          height="10px"
          className="text-gray-7"
        />
      </button>

      {/* ✅ Course List Requirement History Table */}
      {historyCourseListRequirements?.length > 0 ? (
        <>
          <div className="fs-4 fw-bold">History</div>
          <table className="table table-striped table-responsive">
            <thead style={{ whiteSpace: 'nowrap' }}>
              <tr>
                <th>Changes</th>
                <th>List Item</th>
                {/* <th>Credit Hours</th> */}
                <th>Updated By</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {historyCourseListRequirements.map((item, index) => {
                let beforeObject = {},
                  afterObject = {};
                let listItemDescr = '';

                try {
                  beforeObject =
                    typeof item.before === 'string'
                      ? JSON.parse(item.before)
                      : item.before;
                  afterObject =
                    typeof item.after === 'string'
                      ? JSON.parse(item.after)
                      : item.after;

                  console.log('itemAction: ', item.action);
                  const formattedDate = new Date(
                    item.updatedOn
                  ).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                  });

                  // const creditHours =
                  // afterObject?.maxHours && afterObject?.maxHours !== 0
                  //   ? `${afterObject.hours} - ${afterObject.maxHours}`
                  //   : afterObject?.hours;

                  if (item.action === 'REQUIREMENT-MODIFY') {
                    console.log('item: ', item);
                    const differences = compareObjects(
                      item.before,
                      item.after,
                      true
                    );

                    return (
                      <tr key={index}>
                        <td className="text-nowrap">
                          {actionLabelMap[item.action] || item.action}
                        </td>
                        <td>
                          <div key={index} className="history-item">
                            <div>
                              {differences.length > 0 ? (
                                differences.map((diff, diffIndex) => (
                                  <span key={diffIndex}>
                                    <div
                                      style={{ whiteSpace: 'pre-line' }}
                                      dangerouslySetInnerHTML={{
                                        __html: diff.obj1,
                                      }}
                                    />
                                    <div className="text-teal-background">
                                      Changed to:
                                    </div>

                                    <div
                                      style={{ whiteSpace: 'pre-line' }}
                                      dangerouslySetInnerHTML={{
                                        __html: diff.obj2,
                                      }}
                                    />
                                  </span>
                                ))
                              ) : (
                                <div>No differences</div>
                              )}
                            </div>
                            {/* <hr style={{ margin: '1rem' }} /> */}
                          </div>
                        </td>
                        {/* <td>{creditHours}</td> */}
                        <td>{item.updatedBy}</td>
                        <td>{formattedDate}</td>
                      </tr>
                    );
                  } else if (item.action === 'REQUIREMENT-ADDED') {
                    listItemDescr = getCoursesDescr(
                      afterObject?.courses || [],
                      courseLists,
                      true
                    );

                    return (
                      <tr key={index}>
                        <td className="text-nowrap">
                          {actionLabelMap[item.action] || item.action}
                        </td>
                        <td
                          style={{ whiteSpace: 'pre-line' }}
                          dangerouslySetInnerHTML={{ __html: listItemDescr }}
                        />

                        {/* <td>{creditHours}</td> */}
                        <td>{item.updatedBy}</td>
                        <td>{formattedDate}</td>
                      </tr>
                    );
                  } else if (item.action === 'REQUIREMENT-DELETE') {
                    listItemDescr = getCoursesDescr(
                      beforeObject?.courses || [],
                      courseLists,
                      true
                    );

                    return (
                      <tr key={index}>
                        <td className="text-nowrap">
                          {actionLabelMap[item.action] || item.action}
                        </td>
                        <td
                          style={{ whiteSpace: 'pre-line' }}
                          dangerouslySetInnerHTML={{ __html: listItemDescr }}
                        />
                        {/* <td>{creditHours}</td> */}
                        <td>{item.updatedBy}</td>
                        <td>{formattedDate}</td>
                      </tr>
                    );
                  }
                } catch (error) {
                  console.error('Error processing item:', error);
                  listItemDescr = '(Error parsing data)';
                }
                return null;
              })}
            </tbody>
          </table>
        </>
      ) : hasDeleted ? (
        <>
          <strong>{subsectionName}</strong>
          <h3>
            <FontAwesomeIcon
              icon={faTrash}
              title="Deleted requirements"
              className="fa-trash-inactive pe-1"
              style={{ width: '25px' }}
            />
            Deleted requirements
          </h3>
          <table className="table table-striped table-responsive">
            <thead style={{ whiteSpace: 'nowrap' }}>
              <tr>
                <th>Requirements</th>
                <th>Credit Hours</th>
                <th>Deleted By</th>
                <th>Date and time</th>
              </tr>
            </thead>
            <tbody>
              {historyDeleted.map((item, index) => {
                let beforeObject = {};
                try {
                  beforeObject =
                    typeof item.before === 'string'
                      ? JSON.parse(item.before)
                      : item.before;
                } catch (error) {
                  console.error(
                    `Error parsing item.before at index ${index}:`,
                    error
                  );
                  return null;
                }

                return (
                  <tr key={index}>
                    <td
                      style={{ whiteSpace: 'pre-line' }}
                      dangerouslySetInnerHTML={{
                        __html: getCoursesDescr(
                          beforeObject.courses ?? [],
                          courseLists
                        ),
                      }}
                    />
                    <td>
                      {beforeObject.maxHours && beforeObject.maxHours !== 0
                        ? `${beforeObject.hours} - ${beforeObject.maxHours}`
                        : beforeObject.hours}
                    </td>
                    <td>{item.updatedBy}</td>
                    <td>
                      {new Date(item.updatedOn).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                      })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : reverseData.length > 0 ? (
        <>
          <h3>Changes</h3>
          {reverseData.map((value, index) => {
            const formattedDate = new Date(value.updatedOn).toLocaleString(
              'en-US',
              {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              }
            );

            const differences = compareObjects(value.before, value.after);

            return (
              <div key={index} className="history-item">
                <div>
                  {value.updatedBy} * {formattedDate}
                </div>
                <div>
                  {differences.length > 0 ? (
                    differences.map((diff, diffIndex) => (
                      <span key={diffIndex}>
                        <div>
                          <strong>
                            {diff.key.replace(/^\w/, (c) => c.toUpperCase())}{' '}
                            Changed to:
                          </strong>
                        </div>
                        <div
                          style={{ whiteSpace: 'pre-line' }}
                          dangerouslySetInnerHTML={{ __html: diff.obj2 }}
                        />
                      </span>
                    ))
                  ) : (
                    <div>No differences</div>
                  )}
                </div>
                <hr style={{ margin: '1rem' }} />
              </div>
            );
          })}
        </>
      ) : (
        <p style={{ textAlign: 'center', marginTop: '2rem' }}>
          No history available.
        </p>
      )}
    </div>
  );
}

export default HistoryDetails;
